module.exports = __webpack_public_path__ + "static/introducing-mannequin.311e1bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blog-posts/introducing-mannequin.jpg
// module id = 515
// module chunks = 35783957827783